export default __webpack_public_path__ + "static/media/layher.aefb741e.png";